export enum AnsibleBoolean {
  TRUE = 'True',
  FALSE = 'False'
}
